import {
  EXPORT_PCA_REPORT,
  EXPORT_PCA_REPORT_FAILURE,
  EXPORT_PCA_REPORT_SUCCESS,
  RESET_EXPORT_PCA_REPORT,

  PCA_FIND_CM,
  PCA_FIND_CM_SUCCESS,
  PCA_FIND_CM_FAILURE,
  RESET_PCA_FIND_CM,

  PCA_FETCH_ALL_ACTIVE_SKILLS_SUCCESS,
  // PCA_FETCH_ALL_ACTIVE_SKILLS,
  // PCA_FETCH_ALL_ACTIVE_SKILLS_FAILURE,

  CREATE_PCA_RECORD,
  CREATE_PCA_RECORD_SUCCESS,
  CREATE_PCA_RECORD_FAILURE,  
  RESET_CREATE_PCA_RECORD,

  GET_ALL_REGISTERED_CM_PCA,
  GET_ALL_REGISTERED_CM_FAILURE_PCA,
  GET_ALL_REGISTERED_CM_SUCCESS_PCA,

  GET_CM_PCA_BY_ID,
  GET_CM_PCA_BY_ID_SUCCESS,
  GET_CM_PCA_BY_ID_FAILURE,
  GET_CM_PCA_BY_ID_RESET,

  EDIT_PCA_DATA,
  EDIT_PCA_DATA_SUCCESS,
  EDIT_PCA_DATA_FAILURE,
  EDIT_PCA_DATA_RESET, 
} from "../ActionTypes"; 

const INIT_STATE = {
  fetchingReport: false,
  reportFetchSuccess: false,

  cmDetails: {}, // for create purposes
  fetchingCM: false,
  fetchCMSuccess: false,

  allActiveSkills: [],

  creatingPCARecord: false,
  createPCASuccess: false,

  listOfRegisteredCmPca: [],
  fetchingRegisteredCm: false,
  fetchRegisteredCmSuccess: false,

  singleCmData: {}, //  for edit cm pca record
  fetchingSingleCmData: false,
  fetchSingleCmDataSuccess: false,

  savingPcaEdits: false,
  pcaEditsSavedSuccessfully: false,
}

function reducers(state = INIT_STATE, action) {
  switch (action.type) {
    case EXPORT_PCA_REPORT: return {
      ...state,
      fetchingReport: true,
    }

    case EXPORT_PCA_REPORT_SUCCESS: return {
      ...state,
      fetchingReport: false,
      reportFetchSuccess: true,
    }

    case EXPORT_PCA_REPORT_FAILURE: return {
      ...state,
      fetchingReport: false,
      reportFetchSuccess: false,
    }

    case RESET_EXPORT_PCA_REPORT: return {
      ...state,
      fetchingReport: false,
      reportFetchSuccess: false,
    }

    case PCA_FIND_CM: return {
      ...state,
      fetchingCM: true,
    }

    case PCA_FIND_CM_SUCCESS: {
      return {
        ...state,
        fetchingCM: false,
        fetchCMSuccess: true,
        cmDetails: {
          ...action.payload,
        }
      }
    }

    case PCA_FIND_CM_FAILURE: return {
      ...state,
      fetchingCM: false,
      fetchCMSuccess: false,
    }

    case RESET_PCA_FIND_CM: return {
      ...state,
      cmDetails: {},
      fetchingCM: false,
      fetchCMSuccess: false,
    }

    case PCA_FETCH_ALL_ACTIVE_SKILLS_SUCCESS: {
      let filteredList = []

      action.payload.map(skill => {
        filteredList.push({
          label: skill.name,
          value: skill.id,
        })
      })

      const newState = {
        ...state,
        allActiveSkills: filteredList
      }

      return newState;
    }

    case CREATE_PCA_RECORD: return {
      ...state,
      creatingPCARecord: true,
    }

    case CREATE_PCA_RECORD_SUCCESS: return {
      ...state,
      creatingPCARecord: false,
      createPCASuccess: true,
    }

    case CREATE_PCA_RECORD_FAILURE: return {
      ...state,
      creatingPCARecord: false,
      createPCASuccess: false,
    }

    case RESET_CREATE_PCA_RECORD: return {
      ...state,
      creatingPCARecord: false,
      createPCASuccess: false,
    }

    case GET_ALL_REGISTERED_CM_PCA: return {
      ...state,
      fetchingRegisteredCm: true,
    }

    case GET_ALL_REGISTERED_CM_SUCCESS_PCA: return {
      ...state,
      fetchingRegisteredCm: false,
      fetchRegisteredCmSuccess: true,
      listOfRegisteredCmPca: action.payload.data,
      registeredCmMetaData: action.payload.meta,
    }

    case GET_ALL_REGISTERED_CM_FAILURE_PCA: return {
      ...state,
      fetchingRegisteredCm: false,
      fetchRegisteredCmSuccess: false,
    }

    case GET_CM_PCA_BY_ID: return {
      ...state,
      fetchingSingleCmData: true,
    }

    case GET_CM_PCA_BY_ID_SUCCESS: return {
      ...state,
      fetchingSingleCmData: false,
      fetchSingleCmDataSuccess: true,
      singleCmData: action.payload,
    }

    case GET_CM_PCA_BY_ID_FAILURE: return {
      ...state,
      fetchingSingleCmData: false,
      fetchSingleCmDataSuccess: false,
    }
    
    case GET_CM_PCA_BY_ID_RESET: return {
      ...state,
      fetchSingleCmDataSuccess: false,
      fetchingSingleCmData: false, 
      singleCmData: {},
    }

    case EDIT_PCA_DATA: return {
      ...state,
      savingPcaEdits: true,
    }

    case EDIT_PCA_DATA_SUCCESS: return {
      ...state,
      savingPcaEdits: false,
      pcaEditsSavedSuccessfully: true
    }

    case EDIT_PCA_DATA_FAILURE: return {
      ...state,
      savingPcaEdits: false,
      pcaEditsSavedSuccessfully: false
    }

    case EDIT_PCA_DATA_RESET: return {
      ...state,
      savingPcaEdits: false,
      pcaEditsSavedSuccessfully: false
    }

    default: return state;
  }
}

export default reducers;